import { ThemeProvider } from '@material-ui/core'
import { setAllowMoreProjects } from '@root-gipro/modules/commonProjects/store/actions'
import { HeaderAvatar, HeaderNav } from '@root-gipro/modules/header'
import styles from '@root-gipro/modules/header/styles/Header.module.scss'
import { Routes } from '@root-gipro/router'
import { logout } from '@root-gipro/store/actions/auth'
import { IState } from '@root-gipro/store/interfaces/state'
import { headerTheme } from '@root-gipro/styles/themes'
import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

const HeaderContainer: FC = () => {
	const { allowMoreProjects } = useSelector((state: IState) => state.commonProjects)
	const dispatch = useDispatch()
	const { pathname } = useLocation()

	useEffect(() => {
		if (!allowMoreProjects) {
			dispatch(setAllowMoreProjects(true))
		}
	}, [pathname])

	return (
		<ThemeProvider theme={headerTheme}>
			<div data-header-animate className={styles.header}>
				<div className={`container ${styles.headerContainer}`}>
					<div className={styles.container}>
						<div style={{ width: 256 }}>
							<Link to={Routes.USER_PROJECTS}>
								<img src={'/assets/images/svg/new-logo.svg'} alt='LOGO' />
							</Link>
						</div>
						<HeaderNav />
					</div>
					<HeaderAvatar logout={() => dispatch(logout())} />
				</div>
			</div>
		</ThemeProvider>
	)
}

export default HeaderContainer
